<script setup></script>

<template>
  <svg
    viewBox="0 0 160 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="logo"
  >
    <path d="M0 0H160V80H0V0Z" fill="#0072AB" />
    <path
      d="M28.744 48.16C27.576 48.16 26.568 48 25.72 47.68C24.872 47.344 24.168 46.888 23.608 46.312C23.064 45.72 22.656 45.024 22.384 44.224C22.128 43.408 22 42.512 22 41.536V31.192H25.744V41.224C25.744 41.896 25.816 42.472 25.96 42.952C26.12 43.416 26.328 43.8 26.584 44.104C26.856 44.392 27.176 44.6 27.544 44.728C27.928 44.856 28.344 44.92 28.792 44.92C29.704 44.92 30.44 44.64 31 44.08C31.576 43.52 31.864 42.568 31.864 41.224V31.192H35.608V41.536C35.608 42.512 35.472 43.408 35.2 44.224C34.928 45.04 34.512 45.744 33.952 46.336C33.392 46.912 32.68 47.36 31.816 47.68C30.952 48 29.928 48.16 28.744 48.16Z"
      fill="white"
    />
    <path
      d="M51.1847 33.784C50.6727 34.312 50.0647 35 49.3607 35.848C48.6567 36.68 47.9287 37.592 47.1768 38.584C46.4248 39.576 45.6807 40.6 44.9447 41.656C44.2087 42.712 43.5527 43.72 42.9767 44.68H51.4488V47.824H38.3688V45.592C38.8168 44.776 39.3607 43.872 40.0007 42.88C40.6567 41.872 41.3368 40.864 42.0407 39.856C42.7447 38.832 43.4567 37.848 44.1768 36.904C44.9128 35.944 45.5928 35.088 46.2168 34.336H38.7528V31.192H51.1847V33.784Z"
      fill="white"
    />
    <path
      d="M59.8812 48.04C58.9692 48.04 58.0572 48.008 57.1452 47.944C56.2492 47.896 55.3132 47.768 54.3372 47.56V31.432C55.1052 31.288 55.9452 31.184 56.8572 31.12C57.7692 31.04 58.6172 31 59.4012 31C60.4572 31 61.4252 31.08 62.3052 31.24C63.2012 31.384 63.9692 31.64 64.6092 32.008C65.2492 32.376 65.7452 32.864 66.0972 33.472C66.4652 34.064 66.6492 34.8 66.6492 35.68C66.6492 37.008 66.0092 38.056 64.7292 38.824C65.7852 39.224 66.5052 39.768 66.8892 40.456C67.2732 41.144 67.4652 41.92 67.4652 42.784C67.4652 44.528 66.8252 45.84 65.5452 46.72C64.2812 47.6 62.3932 48.04 59.8812 48.04ZM57.9852 40.576V44.872C58.2572 44.904 58.5532 44.928 58.8732 44.944C59.1932 44.96 59.5452 44.968 59.9292 44.968C61.0492 44.968 61.9532 44.808 62.6412 44.488C63.3292 44.168 63.6732 43.576 63.6732 42.712C63.6732 41.944 63.3852 41.4 62.8092 41.08C62.2332 40.744 61.4092 40.576 60.3372 40.576H57.9852ZM57.9852 37.72H59.8092C60.9612 37.72 61.7852 37.576 62.2812 37.288C62.7772 36.984 63.0252 36.504 63.0252 35.848C63.0252 35.176 62.7692 34.704 62.2572 34.432C61.7452 34.16 60.9932 34.024 60.0012 34.024C59.6812 34.024 59.3372 34.032 58.9692 34.048C58.6012 34.048 58.2732 34.064 57.9852 34.096V37.72Z"
      fill="white"
    />
    <path
      d="M70.7022 47.824V31.192H81.9342V34.336H74.4462V37.6H81.0942V40.672H74.4462V44.68H82.4862V47.824H70.7022Z"
      fill="white"
    />
    <path
      d="M95.3129 47.824C94.9769 47.28 94.5769 46.696 94.1129 46.072C93.6649 45.432 93.1689 44.8 92.6249 44.176C92.0969 43.536 91.5449 42.928 90.9689 42.352C90.3929 41.76 89.8169 41.24 89.2409 40.792V47.824H85.4969V31.192H89.2409V37.48C90.2169 36.456 91.1929 35.392 92.1689 34.288C93.1609 33.168 94.0809 32.136 94.9289 31.192H99.3689C98.2329 32.536 97.0889 33.832 95.9369 35.08C94.8009 36.328 93.6009 37.584 92.3369 38.848C93.6649 39.952 94.9449 41.264 96.1769 42.784C97.4249 44.304 98.6169 45.984 99.7529 47.824H95.3129Z"
      fill="white"
    />
    <path
      d="M106.157 45.928C106.157 46.648 105.925 47.2 105.461 47.584C105.013 47.952 104.501 48.136 103.925 48.136C103.349 48.136 102.829 47.952 102.365 47.584C101.917 47.2 101.693 46.648 101.693 45.928C101.693 45.208 101.917 44.664 102.365 44.296C102.829 43.912 103.349 43.72 103.925 43.72C104.501 43.72 105.013 43.912 105.461 44.296C105.925 44.664 106.157 45.208 106.157 45.928Z"
      fill="white"
    />
    <path
      d="M118.855 47.824C118.519 47.28 118.119 46.696 117.655 46.072C117.207 45.432 116.711 44.8 116.167 44.176C115.639 43.536 115.087 42.928 114.511 42.352C113.935 41.76 113.359 41.24 112.783 40.792V47.824H109.039V31.192H112.783V37.48C113.759 36.456 114.735 35.392 115.711 34.288C116.703 33.168 117.623 32.136 118.471 31.192H122.911C121.775 32.536 120.631 33.832 119.479 35.08C118.343 36.328 117.143 37.584 115.879 38.848C117.207 39.952 118.487 41.264 119.719 42.784C120.967 44.304 122.159 45.984 123.295 47.824H118.855Z"
      fill="white"
    />
    <path
      d="M138.008 33.784C137.496 34.312 136.888 35 136.184 35.848C135.48 36.68 134.752 37.592 134 38.584C133.248 39.576 132.504 40.6 131.768 41.656C131.032 42.712 130.376 43.72 129.8 44.68H138.272V47.824H125.192V45.592C125.64 44.776 126.184 43.872 126.824 42.88C127.48 41.872 128.16 40.864 128.864 39.856C129.568 38.832 130.28 37.848 131 36.904C131.736 35.944 132.416 35.088 133.04 34.336H125.576V31.192H138.008V33.784Z"
      fill="white"
    />
  </svg>
</template>

<style scoped>
.logo {
  max-width: 160px;
  width: 100%;
  height: 80px;
}

@media (max-width: 768px) {
  .logo {
    max-width: 112px;
    height: 100%;
  }
}
</style>
